"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportTransactionsRequestStatus = exports.ScheduleStatus = exports.PendingBankAccountStatus = exports.PaymentFrequency = exports.PaymentAmountOption = exports.BankAccountType = exports.AccountStatus = exports.AccountEndpoints = void 0;
var AccountEndpoints;
(function (AccountEndpoints) {
    AccountEndpoints["AddBankAccount"] = "/accounts/add-bank-account";
    AccountEndpoints["AddPendingBankAccount"] = "/accounts/add-pending-bank-account";
    AccountEndpoints["CancelPayment"] = "/accounts/cancel-payment";
    AccountEndpoints["DeleteBankAccount"] = "/accounts/delete-bank-account";
    AccountEndpoints["DeletePendingBankAccount"] = "/accounts/delete-pending-bank-account";
    AccountEndpoints["GetAccountSummaries"] = "/accounts/get-account-summaries";
    AccountEndpoints["GetAccountSummariesV2"] = "/accounts/v2/get-account-summaries";
    AccountEndpoints["GetBankAccounts"] = "/accounts/get-bank-accounts";
    AccountEndpoints["GetPlaidLinkToken"] = "/accounts/get-plaid-link-token";
    AccountEndpoints["GetScheduledPaymentsByAccount"] = "/accounts/get-scheduled-payments-by-account";
    AccountEndpoints["GetScheduledPaymentsByUser"] = "/accounts/get-scheduled-payments-by-user";
    AccountEndpoints["GetExportedStatementUrl"] = "/accounts/get-exported-statement-url";
    AccountEndpoints["GetStatements"] = "/accounts/get-statements";
    AccountEndpoints["GetStatementUrl"] = "/accounts/get-statement-url";
    AccountEndpoints["SchedulePayment"] = "/accounts/schedule-payment";
    AccountEndpoints["UpdateScheduledPayment"] = "/accounts/update-scheduled-payment";
})(AccountEndpoints || (exports.AccountEndpoints = AccountEndpoints = {}));
/*
 * Account can active, frozen, or closed.
 * These statuses need to be updated with our processor as well as within our own system.
 */
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["Unspecified"] = "ACCOUNT_STATUS_UNSPECIFIED";
    /** Account is active and in good standing. */
    AccountStatus["Active"] = "ACTIVE";
    /**
     * Account activity is frozen
     * This could be for a variety of reasons, including suspected fraudulent activity.
     */
    AccountStatus["Frozen"] = "FROZEN";
    /** Account has been permanently closed. */
    AccountStatus["Closed"] = "CLOSED";
    /** Account has missed payment(s) */
    AccountStatus["Delinquent"] = "DELINQUENT";
    /**
     * Account has an amount of debt is unlikely to be collected.
     * A charge-off is a form of write-off.
     * Traditionally, creditors make this declaration at the point of six months without payment.
     */
    AccountStatus["ChargedOff"] = "CHARGED_OFF";
    /**
     * Ops will update this when the account is placed into Collections via Admin Panel
     * CC will map the collections status to the “closed” generated status
     */
    AccountStatus["Collections"] = "COLLECTIONS";
    /**
     * Account is closed for confirmed bankruptcy, set in Admin Panel
     */
    AccountStatus["Bankruptcy"] = "BANKRUPTCY";
    /**
     * Cardholder is deceased, set in Admin Panel
     */
    AccountStatus["Deceased"] = "DECEASED";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var PaymentAmountOption;
(function (PaymentAmountOption) {
    PaymentAmountOption["Unspecified"] = "PAYMENT_AMOUNT_OPTION_UNSPECIFIED";
    /**
     * The amount that must be paid by the due date to avoid becoming late.
     * Paying this amount will ensure that no late fees are charged.
     */
    PaymentAmountOption["MinimumPaymentDue"] = "MINIMUM_PAYMENT_DUE";
    /**
     * The new balance on the statement. It doesn't reflect any payments or
     * new transactions since the statement close date.
     */
    PaymentAmountOption["StatementBalance"] = "STATEMENT_BALANCE";
    /** The current balance on the account, including all new payments and transactions. */
    PaymentAmountOption["CurrentBalance"] = "CURRENT_BALANCE";
    /** Custom, fixed amount. */
    PaymentAmountOption["FixedAmount"] = "FIXED_AMOUNT";
})(PaymentAmountOption || (exports.PaymentAmountOption = PaymentAmountOption = {}));
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["Unspecified"] = "PAYMENT_FREQUENCY_UNSPECIFIED";
    /**Payment will be made once. */
    PaymentFrequency["OneTime"] = "ONE_TIME";
    /** Recurring payment, will always happen on the due date for the account. */
    PaymentFrequency["AutomaticPaymentDueDate"] = "AUTOMATIC_PAYMENT_DUE_DATE";
})(PaymentFrequency || (exports.PaymentFrequency = PaymentFrequency = {}));
var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["Unspecified"] = "SCHEDULE_STATUS_UNSPECIFIED";
    /**
     * Payment schedule has been created, but payment has not yet initiated.
     * Payment can still be updated/cancelled.
     */
    ScheduleStatus["Active"] = "ACTIVE";
    /** Payment from this schedule failed. */
    ScheduleStatus["Failed"] = "FAILED";
    /**
     * Payment from this schedule has been completed.
     * Only applicable for one-time payment schedules.
     * For recurring payments, the schedule status will remain "ACTIVE" after each payment has been completed.
     * Once a payment schedule is "COMPLETED", the payment from this schedule should appear in the transactions list.
     */
    ScheduleStatus["Completed"] = "COMPLETED";
    /** Payment has been cancelled by the user. */
    ScheduleStatus["Cancelled"] = "CANCELLED";
})(ScheduleStatus || (exports.ScheduleStatus = ScheduleStatus = {}));
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["Unspecified"] = "BANK_ACCOUNT_TYPE_UNSPECIFIED";
    BankAccountType["Checking"] = "CHECKING";
    BankAccountType["Savings"] = "SAVINGS";
})(BankAccountType || (exports.BankAccountType = BankAccountType = {}));
var PendingBankAccountStatus;
(function (PendingBankAccountStatus) {
    PendingBankAccountStatus["Unspecified"] = "PENDING_BANK_ACCOUNT_STATUS_UNSPECIFIED";
    /** Bank account will be verified or rejected without any additional user input. */
    PendingBankAccountStatus["PendingAutomaticVerification"] = "PENDING_AUTOMATIC_VERIFICATION";
    /**
     * Verification requires user input.
     * e.g. verifying microdeposits
     */
    PendingBankAccountStatus["PendingManualVerification"] = "PENDING_MANUAL_VERIFICATION";
    /**
     * Verification has expired.
     * User will need to attempt the verification again.
     */
    PendingBankAccountStatus["VerificationExpired"] = "VERIFICATION_EXPIRED";
})(PendingBankAccountStatus || (exports.PendingBankAccountStatus = PendingBankAccountStatus = {}));
var ExportTransactionsRequestStatus;
(function (ExportTransactionsRequestStatus) {
    ExportTransactionsRequestStatus["EXPORT_TRANSACTIONS_REQUEST_STATUS_UNSPECIFIED"] = "EXPORT_TRANSACTIONS_REQUEST_STATUS_UNSPECIFIED";
    ExportTransactionsRequestStatus["PENDING"] = "PENDING";
    ExportTransactionsRequestStatus["SUCCESS"] = "SUCCESS";
    ExportTransactionsRequestStatus["ERROR"] = "ERROR";
    ExportTransactionsRequestStatus["NOT_SENT"] = "NOT_SENT";
})(ExportTransactionsRequestStatus || (exports.ExportTransactionsRequestStatus = ExportTransactionsRequestStatus = {}));
